import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrendingSection from "./components/TrendingSection";
import ExclusiveSection from "./components/ExclusiveSection";
import SubscribeSection from "./components/SubscribeSection";

export default function HomePage() {
  useEffect(() => {
    document.title =
      "黑料吃瓜网 - 黑料吃瓜网站与每日大赛 | 网红明星塌房现场实时追踪";
  }, []);

  return (
    <>
      {/* SEO JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "黑料吃瓜网 - 全网独家爆料",
          description:
            "黑料吃瓜网站实时追踪网红明星塌房现场与每日大赛独家吃瓜爆料",
          url: "http://obyqdiy.cn/",
          isPartOf: {
            "@type": "WebSite",
            name: "黑料吃瓜网",
            url: "http://obyqdiy.cn/",
          },
        })}
      </script>

      <div className="min-h-screen">
        <Navbar />
        <main>
          <HeroSection />
          <TrendingSection />
          <ExclusiveSection />
          <SubscribeSection />
        </main>
        <Footer />
      </div>
    </>
  );
}